import { render, staticRenderFns } from "./PageAiCreator.vue?vue&type=template&id=246c3497"
import script from "./PageAiCreator.vue?vue&type=script&lang=js"
export * from "./PageAiCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246c3497')) {
      api.createRecord('246c3497', component.options)
    } else {
      api.reload('246c3497', component.options)
    }
    module.hot.accept("./PageAiCreator.vue?vue&type=template&id=246c3497", function () {
      api.rerender('246c3497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page-ai-creator/PageAiCreator.vue"
export default component.exports